var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureDevopsPinelineIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9551 5.99158V25.4474L23.9663 32L11.5837 27.485V31.9596L4.57335 22.7905L25.0076 24.3882V6.87125L31.9551 5.99158ZM25.1467 6.97447L13.6797 0V4.57335L3.15512 7.67013L0 11.7229V20.9324L4.51501 22.9296V11.1259L25.1467 6.97447Z",
    fill: "url(#paint0_linear_317_5759)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_5759",
    x1: 15.9774,
    y1: 31.9006,
    x2: 15.9774,
    y2: 0.0616843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2974BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2F7BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4B8CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5F98D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#679CD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDevopsPinelineIntegration);
export default __webpack_public_path__ + "static/media/azure-devops-pineline-integration.d279e41710f438516ee5a971ac1bbd34.svg";
export { ForwardRef as ReactComponent };